export class Commonmaster {
    Id : number;
    Code :string;
	Name : string;
	IsHeadOffice : boolean;
    IsEnquiry : number;
    IsSurvey : number;
    BranchId : number; // Branch Id is adding for appending the BranchId to the transaction No. In collection sheet
}


